/**
 * Localize order status values from the API/DB for display only.
 */

const STATUS_KEYS = {
  filled: 'tables.statusFilled',
  cancelled: 'tables.statusCancelled',
  canceled: 'tables.statusCancelled',
  rejected: 'tables.statusRejected',
  expired: 'tables.statusExpired',
  pending: 'tables.statusPending',
};

export function translateOrderStatus(status, t) {
  if (status == null || status === '' || status === '---') return status || '---';
  const key = STATUS_KEYS[String(status).trim().toLowerCase()];
  return key ? t(key) : status;
}
